import { render, staticRenderFns } from "./cabinet-fl44-card-body.vue?vue&type=template&id=27a5b2c8&scoped=true&"
import script from "./cabinet-fl44-card-body.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-card-body.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-card-body.vue?vue&type=style&index=0&id=27a5b2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5b2c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a5b2c8')) {
      api.createRecord('27a5b2c8', component.options)
    } else {
      api.reload('27a5b2c8', component.options)
    }
    module.hot.accept("./cabinet-fl44-card-body.vue?vue&type=template&id=27a5b2c8&scoped=true&", function () {
      api.rerender('27a5b2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-card-body.vue"
export default component.exports